<action-box *ngIf="visible" class="detail-item {{extraStyles}}" iconLeft="form" textLeft="{{actionBoxTitle}}">
  <ng-container *ngIf="contentVisible">
    <form-panel *ngFor="let form of forms"
                [configurationId]="configurationId"
                [panel]="form"
                [id]="form.longId"
                [showTitle]="false"
                [view]="RequestViews.Summary"></form-panel>
  </ng-container>
  <div card-type="control" *ngIf="isPrintView">
    <print-checkbox (onValueChange)="onPrintValueChange($event)"></print-checkbox>
  </div>
</action-box>